'use client';

import { useLayoutEffect } from 'react';

import { usePathname, useRouter } from 'next/navigation';

import { useOnboardingStatus } from '@/apis/forced_onboarding/hooks';

export const Onboarding = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { data: onboardingStatus } = useOnboardingStatus();
  useLayoutEffect(() => {
    // free, lite, or pro+ users dont enter the forced flow
    if (!onboardingStatus) {
      // lite, free, or pro+ users dont enter the forced flow
      return;
    }
    if (onboardingStatus?.next_step === 'create_team') {
      router.push('/onboarding/team/business?step=create_team');
      return;
    }
    if (onboardingStatus?.next_step === 'invite_member') {
      router.push('/onboarding/team/business?step=invite_member');
      return;
    }

    // they finished the flow, so show the UI
  }, [router, pathname, onboardingStatus]);

  return null;
};

export default Onboarding;
